import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Button } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import InputTile from './InputTile';
import {
  getSpouseSocialSecurityAdvice,
  getParticipantSocialSecurityAdvice,
  getTotalCompensation,
  getSpouseSalary,
  getIncomeGoal,
  getSuggestedTotalContribution,
  getSuggestedContributionAsJson,
  getRetirementAgeAdvice,
  getMultiClientInforation,
  getMulticlientAggregatedCompensation,
} from '../../selectors';
import { formatAmountWithoutDecimals, getIntegerAmount, keyDown } from '../../utils/helpers';
import { chartsActions, participantProfileActions } from '../../redux/root-action';
import { isInternal } from '../../utils/api';
import { analyticsTracking, derivedAttributes, postActions, units } from 'utils/constants';
import { modelIncludeInScenario } from 'redux/strategy-modal/actions';

const StyledContainer = styled.div`
  width: 352px;
  position: relative;

  @media only screen and (max-width: 1024px) {
    width: 368px;
  }

  @media (max-width: 1023px) {
    background-color: ${tokens.ColorWhite050};
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    width: 100%;
    padding: 0 40px 52px;
  }

  @media only screen and (max-width: 767px) {
    width: 100%;
    padding: 0 16px 40px;
  }
`;
const PARTICIPANT = 'participant',
  SPOUSE = 'spouse';

//eslint-disable-next-line
let noOfNQPlans: any = [],
  hasAllNQAccounts = false;

class InputTilesContainer extends Component<any> {
  props: any;
  state: any;

  constructor(props: any) {
    super(props);
    this.state = { futureIncomeEntries: 0 };
  }

  getSocialSecurityBenefit = (socialSecurityAge: any, user: string) => {
    const { participantSocialSecurityAdvice, spouseSocialSecurityAdvice } = this.props;
    const socialSecurityAdvice = user === PARTICIPANT ? participantSocialSecurityAdvice : spouseSocialSecurityAdvice;

    if (!socialSecurityAdvice || socialSecurityAdvice.length === 0) {
      return null;
    }

    let socialSecurityAmount = 0;
    socialSecurityAdvice.forEach((item: any) => {
      if (item.StartAge === socialSecurityAge) {
        socialSecurityAmount = item.MonthlyIncome.toFixed(2);
      }
    });

    return socialSecurityAmount;
  };

  cleanUpObjects = (objArr: Array<Record<any, any>>) => {
    return objArr.map((obj: Record<any, any>) => {
      let cleanedObject = {};
      Object.keys(obj).forEach(key => {
        if (!derivedAttributes.includes(key)) {
          cleanedObject = { ...cleanedObject, [key]: obj[key] };
        }
      });
      return cleanedObject;
    });
  };

  buildPostObjectForContributions = () => {
    const {
      contribution: {
        modelledScenario: { contributions },
      },
      strategyModal: {
        modelledScenario: {
          accounts
        },
      }
    } = this.props;

    let postAccounts: Array<Record<any, any>> = [];
    if (!contributions) {
      return {};
    }

    postAccounts = contributions
      .filter((account: any) => account.contribution.some((c: any) => c.updated === true))
      .map((account: any) => ({
        ...account,
        name: undefined,
        contribution: this.cleanUpObjects(
          account.contribution
            .filter((acc: any) => acc.updated)
            .map((cc: any) => ({ ...cc, amount: cc.unit === 'PCT' ? cc.amount / 100 : cc.amount })),
        ),
        action: postActions.UPDATE,
      }));

    let modifiedAccounts: Array<Record<any, any>> = [];

    modifiedAccounts = this.props.riScenario.accounts
      .filter((account: any) => account.action === 'UPDATE')
      .map((account: any) => ({
        accountCategory: account.accountCategory,
        action: account.action,
        bpId: account.bpId,
        century: account.century,
        clientNumber: account.clientNumber,
        displayAccountCategory: account.displayAccountCategory,
        hsaPlanSponsorId: account.hsaPlanSponsorId,
        hsaRecordKeeperId: account.hsaRecordKeeperId,
        id: account.id,
        idmAgreementId: account.idmAgreementId,
        includeInScenario: account.includeInScenario,
        overrideAccountTypeCode: account.overrideAccountTypeCode,
        planNumber: account.planNumber,
        retailTypeCategory: account.retailTypeCategory,
        tracPlanNumber: account.tracPlanNumber,
        type: account.type,
        yodleeAgreementId: account.yodleeAgreementId,
        yodleeInstitutionId: account.yodleeInstitutionId
      }));

    if (postAccounts.length) {
      if (modifiedAccounts.length) {
        postAccounts.push(...modifiedAccounts);
      }
      return {
        accounts: postAccounts,
      };
    }
    return {};
  };

  constructSpouseSalaryRequest = (spouseInformation: any): any => {
    let request: any = {};
    if (spouseInformation !== undefined && spouseInformation !== null) {
      const amountData: number = getIntegerAmount(spouseInformation.amount);
      request = {
        id: spouseInformation.id,
        compensationType: spouseInformation.compensationType,
        bpId: spouseInformation.bpId,
        clientNumber: spouseInformation.clientNumber,
        amount: amountData,
        action: 'UPDATE',
      };
    }
    return request;
  };

  constructOtherIncomeRequest = (otherIncome: any): any => {
    let request: any = {};
    if (otherIncome !== undefined && otherIncome !== null) {
      const amountData: number = getIntegerAmount(otherIncome.amount);
      request = {
        id: otherIncome.id,
        compensationType: otherIncome.compensationType,
        bpId: otherIncome.bpId,
        clientNumber: otherIncome.clientNumber,
        amount: amountData,
        action: 'UPDATE',
      };
    }
    return request;
  };

  constructMulticlientRequest = (multiClientData: any): any => {
    const request: any = [];
    for (let i = 0; i < multiClientData.length; i++) {
      const amountData: number = getIntegerAmount(multiClientData[i].salary);
      request.push({
        id: multiClientData[i].id,
        compensationType: multiClientData[i].compensationType,
        bpId: multiClientData[i].compensationId,
        clientNumber: multiClientData[i].clientNumber,
        payFrequency: multiClientData[i].paymentFrequency,
        tracPlanNumber: multiClientData[i].tracPlanNumber,
        amount: amountData,
        action: 'UPDATE',
      });
    }
    return request;
  };

  constructIncludeInScenarioRequest = (includeInScenarioRequestData: any): any => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const strategyModal: {
      modelledScenario: {
        accounts: any
      },
    } = this.props;
    let modifiedAccounts: Array<Record<any, any>> = [];

    modifiedAccounts = this.props.riScenario.accounts
      .filter((account: any) => account.action === 'UPDATE')
      .map((account: any) => ({
        accountCategory: account.accountCategory,
        action: account.action,
        bpId: account.bpId,
        century: account.century,
        clientNumber: account.clientNumber,
        displayAccountCategory: account.displayAccountCategory,
        hsaPlanSponsorId: account.hsaPlanSponsorId,
        hsaRecordKeeperId: account.hsaRecordKeeperId,
        id: account.id,
        idmAgreementId: account.idmAgreementId,
        includeInScenario: account.includeInScenario,
        overrideAccountTypeCode: account.overrideAccountTypeCode,
        planNumber: account.planNumber,
        retailTypeCategory: account.retailTypeCategory,
        tracPlanNumber: account.tracPlanNumber,
        type: account.type,
        yodleeAgreementId: account.yodleeAgreementId,
        yodleeInstitutionId: account.yodleeInstitutionId
      }));

    if (modifiedAccounts.length) {
      return ({ accounts: modifiedAccounts })
    }
  }

  constructEventsRequest = (eventsRequestData: any) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const events: {
      tempScenario: {
        events: any
      },
      retirementAge: {
        modelledScenario: { retirementStartAge: any, spouseRetirementStartAge: any, retirementEndAge: any },
      },
    } = this.props;

    let modifiedEvents: Array<Record<any, any>> = [];

    modifiedEvents = this.props.events.tempScenario.events
      .filter((event: any) => event.action)
      .map((event: any) => ({
        id: event.id,
        bpId: event.bpId,
        scenarioId: event.scenarioId,
        name: event.name,
        typeName: event.typeName,
        categoryName: event.categoryName,
        amount: event.amount,
        startNumber: event.startNumber,
        endNumber: event.typeName !== 'Annuity' ? event.frequency === 'ONET' ? event.startNumber : event.endNumber : this.props.retirementAge.modelledScenario.retirementEndAge,
        includeInScenario: event.includeInScenario,
        unit: event.unit,
        // frequency: event.typeName !== 'Annuity' ? event.frequency : 'ANL',
        frequency: event.typeName !== 'Annuity' ? event.frequency : 'MLY',
        action: event.action,
        accountKey: null
      }));

    if (modifiedEvents.length) {
      return ({ events: modifiedEvents })
    }
  };

  updateAndSeeImpact = () => {
    const {
      postSimulation,
      retirementAge: {
        modelledScenario: { retirementStartAge, spouseRetirementStartAge, retirementEndAge },
        updatedFields: updatedRetirementAgeFields,
      },
      retirementIncomeGoal: {
        modelledScenario: { incomeGoal },
        updatedFields: updatedRetirementIncomeGoalFields,
      },
      socialSecurity: {
        modelledScenario: {
          socialSecurityStartAge,
          spouseSocialSecurityStartAge,
          socialSecurityAmount,
          spouseSocialSecurityAmount,
        },
        updatedFields: updatedSocialSecurityFields,
      },
      strategyModal: {
        modelledScenario: {
          accounts,
        },
        updatedFields: updatedStrategyModalFields
      },
      events: {
        modelledScenario: {
          events,
        },
        updatedFields: updatedEventFields
      },
      riScenario,
    } = this.props;
    let postObj: any = {};

    const updatedFields = {
      ...updatedRetirementAgeFields,
      ...updatedRetirementIncomeGoalFields,
      ...updatedSocialSecurityFields,
      ...updatedStrategyModalFields,
      ...updatedEventFields,
    };

    Object.keys(updatedFields).forEach(field => {
      switch (field) {
        case 'singlePlanInformationData':
          const { singlePlanInformationData } = updatedRetirementIncomeGoalFields;
          const singlePlanRequest = this.constructMulticlientRequest(singlePlanInformationData);

          if (singlePlanRequest.length > 0) {
            postObj = {
              ...postObj,
              compensations: singlePlanRequest,
            };
          }
          break;

        case 'multiClientInformationData':
          const { multiClientInformationData } = updatedRetirementIncomeGoalFields;
          const multiclientRequest = this.constructMulticlientRequest(multiClientInformationData);

          if (multiclientRequest.length > 0) {
            postObj = {
              ...postObj,
              compensations: multiclientRequest,
            };
          }
          break;
        case 'otherIncome':
          const { otherIncome } = updatedRetirementIncomeGoalFields;
          const otherIncomeRequest = this.constructOtherIncomeRequest(otherIncome);
          if (postObj.compensations) {
            postObj.compensations.push(otherIncomeRequest);
          } else {
            postObj = {
              ...postObj,
              compensations: [otherIncomeRequest],
            };
          }
          break;
        case 'spouseInformationData':
          const { spouseInformationData } = updatedRetirementIncomeGoalFields;
          const spouseSalaryRequest = this.constructSpouseSalaryRequest(spouseInformationData);
          if (postObj.compensations) {
            postObj.compensations.push(spouseSalaryRequest);
          } else {
            postObj = {
              ...postObj,
              compensations: [spouseSalaryRequest],
            };
          }
          break;
        case 'incomeGoal':
          const postIncomeGoal = getIntegerAmount(incomeGoal);
          if (postIncomeGoal !== null && postIncomeGoal !== riScenario.incomeGoal) {
            postObj = {
              ...postObj,
              incomeGoal: postIncomeGoal,
            };
          }
          break;
        case 'spouseRetirementStartAge':
          if (spouseRetirementStartAge !== riScenario.spouseRetirementStartAge) {
            postObj = {
              ...postObj,
              spouseRetirementStartAge,
            };
          }
          break;
        case 'retirementEndAge':
          if (retirementEndAge !== riScenario.retirementEndAge) {
            postObj = {
              ...postObj,
              retirementEndAge,
            };
          }
          break;
        case 'accounts':
          const includeInScenarioUpdated = this.constructIncludeInScenarioRequest(accounts);
          if (includeInScenarioUpdated?.accounts?.length > 0) {
            postObj = {
              ...postObj,
              scenarioId: riScenario.scenarioId,
              scenarioType: riScenario.scenarioType,
              ...includeInScenarioUpdated
            }
          }
          break;

        case 'events':
          const eventsUpdated = this.constructEventsRequest(events);
          // if (eventsUpdated?.events?.length > 0) {
          postObj = {
            ...postObj,
            ...eventsUpdated
          }
          // }
          break;

        case 'retirementStartAge':
          if (retirementStartAge !== riScenario.retirementStartAge) {
            postObj = {
              ...postObj,
              retirementStartAge: parseInt(retirementStartAge),
            };
          }
          break;
        case 'socialSecurityStartAge':
          if (socialSecurityStartAge !== riScenario.socialSecurityStartAge) {
            postObj = {
              ...postObj,
              socialSecurityStartAge,
            };
            // Added user security amount in the payload if it exist in the DB and it's not changed
            if (riScenario.socialSecurityAmount != null && riScenario.socialSecurityAmount === socialSecurityAmount) {
              postObj = {
                ...postObj,
                socialSecurityAmount: riScenario.socialSecurityAmount,
              };
            }
            // Added user security amount in the payload if it exist in the DB and it's changed
            if (riScenario.socialSecurityAmount != null && riScenario.socialSecurityAmount !== socialSecurityAmount) {
              postObj = {
                ...postObj,
                socialSecurityAmount: socialSecurityAmount,
              };
            }
          }
          break;
        case 'spouseSocialSecurityStartAge':
          if (spouseSocialSecurityStartAge !== riScenario.spouseSocialSecurityStartAge) {
            postObj = {
              ...postObj,
              spouseSocialSecurityStartAge,
            };
            // Added spouse security amount in the payload if it exist in the DB and it's not changed
            if (
              riScenario.spouseSocialSecurityAmount != null &&
              riScenario.spouseSocialSecurityAmount === spouseSocialSecurityAmount
            ) {
              postObj = {
                ...postObj,
                spouseSocialSecurityAmount: riScenario.spouseSocialSecurityAmount,
              };
            }
            // Added spouse security amount in the payload if it exist in the DB and it's changed
            if (
              riScenario.spouseSocialSecurityAmount != null &&
              riScenario.spouseSocialSecurityAmount !== spouseSocialSecurityAmount
            ) {
              postObj = {
                ...postObj,
                spouseSocialSecurityAmount: spouseSocialSecurityAmount,
              };
            }
          }
          break;
        case 'socialSecurityAmount':
          if (
            socialSecurityAmount !== null &&
            socialSecurityAmount.toFixed(2) !==
            this.getSocialSecurityBenefit(socialSecurityStartAge, PARTICIPANT)!.toString()
          ) {
            postObj = {
              ...postObj,
              socialSecurityAmount: parseFloat(socialSecurityAmount),
            };
            // Added user age in the payload if user not changed their age
            if (socialSecurityStartAge === riScenario.socialSecurityStartAge) {
              postObj = {
                ...postObj,
                socialSecurityStartAge,
              };
            }
          }
          break;
        case 'spouseSocialSecurityAmount':
          if (
            spouseSocialSecurityAmount !== null &&
            spouseSocialSecurityAmount.toFixed(2) !==
            this.getSocialSecurityBenefit(spouseSocialSecurityStartAge, SPOUSE)!.toString()
          ) {
            postObj = {
              ...postObj,
              spouseSocialSecurityAmount: parseFloat(spouseSocialSecurityAmount),
            };
            // Added spouse age in the payload if user not changed their age
            if (spouseSocialSecurityStartAge === riScenario.spouseSocialSecurityStartAge) {
              postObj = {
                ...postObj,
                spouseSocialSecurityStartAge,
              };
            }
          }
          break;
        default:
          break;
      }
    });

    const finalPostObject = {
      ...postObj,
      ...this.buildPostObjectForContributions(),
    };

    if (Object.keys(finalPostObject).length > 0) {
      postSimulation(finalPostObject);
    }

    const element = document.getElementById('RIXRIOTChart');

    if (element) {
      element.click();
    }
  };// end of update and see impact button function

  onlyUnique = (value: any, index: any, self: any) => {
    return self.indexOf(value) === index;
  };

  render(): JSX.Element {
    const {
      contribution: {
        modelledScenario: { contributions },
      },
      socialSecurity: {
        modelledScenario: { socialSecurityStartAge, spouseSocialSecurityStartAge, hasSpouse },
      },
      retirementAge: {
        modelledScenario: { retirementStartAge, spouseRetirementStartAge },
      },
      retirementIncomeGoal: {
        modelledScenario: { incomeGoal },
      },
      strategyModal: {
        // write accounts here but its throwing an error, might not be required tbh
        modelledScenario
      },
      events: {
        tempScenario: {
          events,
        },
        updatedFields: updatedEventFields
      },
      riScenario,
      participantProfile,
      isLoading,
      initialIncomeGoal,
      totalCompensation,
      spouseSalary,
      // suggestedTotalContribution,
      suggestedContributionData,
      retirementAgeAdvice,
      isMulticlient,
      multiclientAggregatedCompensation,
    } = this.props;

    const { futureIncomeEntries } = this.state;
    const isTermed = participantProfile.status > 19 || isNaN(participantProfile.status);
    const haveMixedUnits = contributions && contributions.some((c: any) => c.planLevelUnit === 'N/A');
    const contributionUnit = haveMixedUnits
      ? ''
      : contributions && contributions.length && contributions[0].planLevelUnit === 'PCT'
        ? '%'
        : '$';
    const totalContributionPercent = haveMixedUnits
      ? ''
      : contributions
        ? contributions.reduce(
          (
            accum: number,
            {
              totalContributionPercent,
              totalContributionAmount,
              planLevelUnit,
              totalContributionPercentCatchUp,
              totalContributionAmountCatchUp,
            }: any,
          ) =>
            accum +
            (planLevelUnit === 'PCT'
              ? totalContributionPercent + (totalContributionPercentCatchUp ? totalContributionPercentCatchUp : 0)
              : totalContributionAmount + (totalContributionAmountCatchUp ? totalContributionAmountCatchUp : 0)),
          0,
        )
        : 0;

    let totalCompensationInfo = totalCompensation;
    if (isMulticlient) {
      totalCompensationInfo = multiclientAggregatedCompensation;
    }

    const compensationPercent =
      totalCompensationInfo > 0
        ? Math.floor(((incomeGoal === null ? initialIncomeGoal : incomeGoal) / totalCompensationInfo) * 100)
        : 0;

    let contributionTileText = '';

    /* if (!haveMixedUnits && suggestedTotalContribution > 0) {
      contributionTileText = suggestedTotalContribution + '% may help you get on track.';
    } else {
      contributionTileText = 'Looks good. Keep it up.';
    } */

    const { accounts = [] } = this.props;

    for (let i = 0; i < accounts.length; i++) {
      if (
        !(accounts[i].contribution && accounts[i].contribution.length > 0) ||
        accounts[i].displayAccountCategory === 'RPSNQAccountSummary' ||
        accounts[i].displayAccountCategory === 'NonQualAccountSummary' ||
        accounts[i].displayAccountCategory === 'RPSNQTRACAccountSummary'
      ) {
        noOfNQPlans.push(accounts[i].planNumber);
      }
    }

    if (noOfNQPlans.filter(this.onlyUnique).length === accounts.length) {
      hasAllNQAccounts = true;
    } else {
      hasAllNQAccounts = false;
    }

    const balanceIncludedInStrategy = accounts.reduce(
      (accum: number, account: any) => accum + ((account.includeInScenario && account.categoryName !== "Pension") ? account.balance : 0),
      0,
    );

    const includedAccounts = accounts.reduce(
      (accum: number, account: any) => accum + ((account.includeInScenario && account.categoryName !== "Pension") ? 1 : 0),
      0,
    );

    let totalAccounts = accounts.reduce(
      (accum: number, account: any) => accum + (account.categoryName !== "Pension" ? 1 : 0),
      0,
    );

    const eventEntries = riScenario.events?.length > 0 ? riScenario.events?.reduce(
      (accum: number, event: any) => accum + (event.includeInScenario ? 1 : 0), 0
    ) : 0

    const totalEventEntries = riScenario.events?.length > 0 ? riScenario.events?.reduce(
      (accum: number, event: any) => accum + (event ? 1 : 0), 0
    ) : 0

    // if (!suggestedContributionData.onTrack && suggestedContributionData.hasMixedUnit) {
    if (suggestedContributionData.hasMixedUnit) {
      contributionTileText = 'An increase may help you get on track.';
      // } else if (!suggestedContributionData.onTrack && !suggestedContributionData.hasMixedUnit) {
    } else if (!suggestedContributionData.hasMixedUnit) {
      let contributionUnit = '';

      for (let i = 0; i < accounts.length; i++) {
        if (
          accounts[i].contribution &&
          accounts[i].contribution.length > 0 &&
          accounts[i].contribution[i] &&
          accounts[i].contribution[i].unit
        ) {
          contributionUnit = accounts[i].contribution[i].unit;
          break;
        }
      }

      if (contributionUnit === 'PCT') {
        contributionTileText = suggestedContributionData.totalSuggestedBreakdown + '% may help you get on track.';
      }

      if (contributionUnit === 'DOL') {
        contributionTileText = `$${suggestedContributionData.totalSuggestedBreakdownAmount} may help you get on track.`;
      }
    } else {
      contributionTileText = 'Looks good. Keep it up.';
    }

    if (
      (suggestedContributionData &&
        suggestedContributionData.allUnits &&
        suggestedContributionData.allUnits[0] === 'PCT' &&
        suggestedContributionData.totalSuggestedBreakdown < 1) ||
      (suggestedContributionData &&
        suggestedContributionData.allUnits &&
        suggestedContributionData.allUnits[0] === 'DOL' &&
        suggestedContributionData.totalSuggestedBreakdownAmount < 1) ||
      (suggestedContributionData && !suggestedContributionData.hasHouseholdAccountAdvice)
    ) {
      contributionTileText = 'Looks good. Keep it up.';
    }

    return (
      <React.Fragment>
        <StyledContainer id={`input-tiles-container`}>
          <InputTile
            id={`retirement-income-goal-title`}
            tile="RetirementIncomeGoal"
            title="Retirement Income Goal"
            subTitle={
              (compensationPercent ? compensationPercent : '') +
              (spouseSalary ? '% of your household salary' : '% of your salary')
            }
            subTitleId={'IT-RIGSalaryPercentage'}
            value={formatAmountWithoutDecimals(incomeGoal === null ? initialIncomeGoal : incomeGoal)}
            valueId={'IT-RIGSalary'}
            position="100"
            analyticsId={analyticsTracking.RIXRIGInputTile}
          />
          {accounts.length > 1 && (
            <InputTile
              id={`strategy-balance-title`}
              tile="strategyBalance"
              title="Strategy Balance"
              subTitle={includedAccounts + ' of ' + totalAccounts + ' accounts included'}
              value={formatAmountWithoutDecimals(balanceIncludedInStrategy)}
              analyticsId={analyticsTracking.RIXStrategyBalanceInputTile}
            />
          )}
          {contributions && contributions.length > 0 && !hasAllNQAccounts && (
            <InputTile
              id={`your-contribution-title`}
              tile="YourContribution"
              title="Your Contribution"
              subTitle={contributionTileText}
              value={
                !suggestedContributionData.hasMixedUnit
                  ? `${contributionUnit === '$' ? '$' : ''}${totalContributionPercent}${contributionUnit === '%' ? '%' : ''
                  }`
                  : ''
              }
              analyticsId={analyticsTracking.RIXContributionsInputTile}
            />
          )}
          <InputTile
            id={`retirement-age-title`}
            tile="RetirementAge"
            title="Retirement Age"
            subTitle={
              retirementAgeAdvice > 0 && !hasSpouse
                ? 'Try retiring at age ' + retirementAgeAdvice + ' or later'
                : 'Delaying may help'
            }
            value={`Age ${retirementStartAge ? retirementStartAge : ''}`}
            spouseValue={hasSpouse ? `Spouse ${spouseRetirementStartAge}` : ''}
            analyticsId={analyticsTracking.RIXRetirementAgeInputTile}
            riScenario={riScenario}
            tempScenarioEvents={this.props.events.tempScenario.events}
          />
          <InputTile
            id={`social-security-title`}
            tile="SocialSecurity"
            title="Social Security"
            subTitle="Wait until age 70 if you can."
            value={`Age ${socialSecurityStartAge ? socialSecurityStartAge : ''}`}
            spouseValue={hasSpouse ? `Spouse ${spouseSocialSecurityStartAge}` : ''}
            analyticsId={analyticsTracking.RIXSocialSecurityInputTile}
          />
          <InputTile
            id={`future-income-expenses`}
            tile="FutureIncomeExpenses"
            title="Future Income/Expenses"
            subTitle="Add/edit inheritance, jobs, healthcare, etc."
            value={eventEntries > 0 ? (eventEntries + ` of ` + totalEventEntries + ` Entries`) : (eventEntries + ` Entries`)}
            analyticsId={analyticsTracking.RIXFutureIncomeInputTile}
          />

          <Button
            title="Update and See Impact"
            type="primary"
            fitContainerWidth={true}
            onClick={this.updateAndSeeImpact}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.updateAndSeeImpact)}
            disabled={isInternal() || isLoading}
            id={analyticsTracking.RIXModelUpdateandShowImpact}
          />
        </StyledContainer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  const {
    account: {
      modelledScenario: { accounts },
    },
    participantProfile,
    charts,
    contribution,
    events,
    riScenario,
    retirementAge,
    retirementIncomeGoal,
    socialSecurity,
    strategyModal,
  } = state;
  return {
    accounts,
    events,
    participantProfile: participantProfile.participantProfile,
    plans: participantProfile.plans,
    simulationCurrentWant: charts.simulationCurrentWant,
    contribution,
    socialSecurity,
    riScenario,
    retirementAge,
    strategyModal,
    retirementIncomeGoal,
    spouseSocialSecurityAdvice: getSpouseSocialSecurityAdvice(state),
    participantSocialSecurityAdvice: getParticipantSocialSecurityAdvice(state),
    isLoading: riScenario.loading || charts.loading,
    initialIncomeGoal: getIncomeGoal(state),
    totalCompensation: getTotalCompensation(state),
    spouseSalary: getSpouseSalary(state),
    suggestedTotalContribution: getSuggestedTotalContribution(state),
    suggestedContributionData: getSuggestedContributionAsJson(state),
    retirementAgeAdvice: getRetirementAgeAdvice(state),
    isMulticlient: getMultiClientInforation(state),
    multiclientAggregatedCompensation: getMulticlientAggregatedCompensation(state),
  };
};

export default connect(mapStateToProps, {
  fetchPlans: participantProfileActions.fetchPlans,
  postSimulation: chartsActions.postSimulation
})(InputTilesContainer);
